import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';

import { ControlledCheckbox, ControlledTextField } from 'components/shared';

export const DutyCodeGeneralFields = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();
  return (
    <Grid container spacing={2.5} mb={2.5}>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          variant="outlined"
          label={t('description')}
          name="description"
        />
      </Grid>
      <Grid item xs={6}>
        <ControlledCheckbox
          control={control}
          label={t('dutyCodes.flags.REQUEST_EXCLUDE')}
          name="flags.REQUEST_EXCLUDE"
        />
      </Grid>
      <Grid item xs={6}>
        <ControlledCheckbox
          control={control}
          label={t('dutyCodes.flags.ROUTE')}
          name="flags.ROUTE"
        />
      </Grid>
    </Grid>
  );
};
